<div class="containers">
  <p>Please select the year to get invoice history.</p>

  <form
    novalidate
    [formGroup]="form"
    (ngSubmit)="onSubmit()"
    class="form-horizontal"
  >
    <div
      class="form-group"
      [ngClass]="{ 'has-error': !f['fiscalYear'].valid && submitted }"
    >
      <label class="inline">Fiscal Year </label>
      <div class="inline-container blog__post-thumb">
        <select class="form-control form-select" formControlName="fiscalYear">
          <option value="0">Select Option</option>
          <option value="2026">2026</option>
          <option value="2025">2025</option>
          <option value="2024">2024</option>
          <option value="2023">2023</option>
          <option value="2022">2022</option>
          <option value="2021">2021</option>
          <option value="2020">2020</option>
          <option value="2018">2018</option>
          <option value="2017">2017</option>
        </select>
        <button class="post-tag">Search</button>
      </div>
    </div>
  </form>

  <br />
  <div *ngIf="isSearched && Activedata">
    <div style="height: 500px; overflow-y: auto">
      <ag-grid-angular
        style="width: 100%; height: 100%"
        class="ag-theme-alpine"
        [rowData]="rowData"
        [animateRows]="true"
        [gridOptions]="gridOptions"
        [columnDefs]="columnDefs"
        rowSelection="multiple"
        [pagination]="true"
        [defaultColDef]="defaultColDef"
        (gridReady)="onGridReady($event)"
      >
      </ag-grid-angular>
    </div>
  </div>
  <div *ngIf="isSearched && Activedata == false">
    <p style="color: rgb(215, 48, 48)">
      No data found. Please try selecting a different year or refresh the page.
    </p>
  </div>
</div>
<br />
